import React, { Component } from 'react';
import {observer} from "mobx-react"
import SortieStore from "../SortieStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Amount from "./Amount"
import Quantite from "./Quantite"
@observer
class ExpertiseSortie extends React.Component {
  constructor(props) {
    super(props);
    this.loadPiece = this.loadPiece.bind(this)
    this.addDegat = this.addDegat.bind(this)
    this.changeAmount = this.changeAmount.bind(this)
    this.state = {
      piece: {},
      pieceid: 0,
      degats: [],
      total: 0,
      degatActuel: ""
    };
    SortieStore.loadPieces()
    this.loadPiece()
  }
  loadPiece(){
    let pieceid = this.props.match.params.pieceid

    axios.post("/api/v1/experts/app/sortie/loadPiece",{id: SortieStore.rdv.id,piece: pieceid}).then((data)=>{
      console.log(data.data)
      this.setState({
        piece: data.data.piece,
        degats: data.data.degats,
        total: data.data.total,
        pieceid: pieceid
      })
    })
  }
  // addQt(degat){
  //   axios.post("/api/v1/experts/app/sortie/addDegat",{id: SortieStore.rdv.id,piece: this.state.pieceid,degat: degat}).then((data)=>{
  //     this.setState({degats: data.data.degats,total: data.data.total})
  //   })
  // }
  addDegat(e){
    e.preventDefault();
    let manuel = false
    let degat = SortieStore.degats.find(element => element.title == this.state.degatActuel)
    if(degat===undefined){
      manuel=true
      console.log("statut",this.state.degatActuel)
      degat = SortieStore.degats[0]
      degat["title"]=this.state.degatActuel
      degat["montant_min"]=0
      degat["montant_max"]=0

    }

    axios.post("/api/v1/experts/app/sortie/addDegat",{id: SortieStore.rdv.id,piece: this.state.pieceid,degat: degat,manuel: manuel}).then((data)=>{
      this.setState({degats: data.data.degats,total: data.data.total,degatActuel: ""})
    })
  }
  // deleteDegat(degat){
  //   axios.post("/api/v1/experts/app/sortie/deleteDegat",{id: SortieStore.rdv.id,piece: this.state.pieceid,degat: degat}).then((data)=>{
  //     this.setState({degats: data.data.degats,total: data.data.total})
  //   })
  // }
  changeAmount(degat){
    axios.post("/api/v1/experts/app/sortie/updateAmount",{id: SortieStore.rdv.id,piece: this.state.pieceid,degat: degat}).then((data)=>{
      this.setState({degats: data.data.degats,total: data.data.total})
    })
  }
  render() {
    if(SortieStore.loaded){

      return(
        <div>
            <h1 className="center">Etat des lieux de sortie | {this.state.piece.titre}</h1>
            <div className="row">
              <table>
                <thead>
                  <tr>
                    <th>titre</th>
                    <th>montant</th>
                    <th> + </th>
                    <th>Qt</th>
                    <th> - </th>

                  </tr>
                </thead>

                <tbody>
                  {this.state.degats.map((degat,index)=>(
                    <tr key={index}>
                      <td>{degat.title}</td>
                      <td style={montant}><Amount onChange={this.changeAmount} key={degat.id} degat={degat}/></td>
                      <Quantite onChange={this.changeAmount} key={degat.id} degat={degat} />
                    </tr>
                  ))}
                  <tr>
                    <th>Total</th>
                    <th colSpan="2">{this.state.total} €</th>
                  </tr>
                  <tr>
                    <td>
                      <Autocomplete
                      id="degat"
                      onChange={(e)=>this.setState({degatActuel: e.target.textContent})}
                      inputValue={this.state.degatActuel}
                      onInputChange={(event, newInputValue) => {
                        if(newInputValue != ""){
                        this.setState({degatActuel: newInputValue})
                      }
                      }}
                      options={SortieStore.degats}
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => <TextField {...params} label="degat" variant="outlined" />}
                      />
                    </td>
                    <td colSpan="2">
                    <a href="" onClick={this.addDegat} className="btn">Ajouter</a>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}
const blocks = {
  display: "inline-block",
  width: "21vw",
  marginLeft: "1.5vw",
  marginRight: "1.5vw",
  marginBottom: "1.5vw"

}

const montant={
  width: "20%"
}

export default ExpertiseSortie
